module.exports = __webpack_public_path__ + "img/AccuFFRivus_Series.04b41992.png";